import {
  addDays,
  addYears,
  endOfDay,
  isAfter,
  isBefore,
  parseISO,
  setYear,
  startOfDay,
} from 'date-fns'
import { Event } from '../types/event'

export const isYearlyRecurringEvent = (event: Event): boolean =>
  event.periodicity === 'everyYear' ||
  event.type === 'Birthday' ||
  event.type === 'Death'

const getEventStartDate = (event: Event): Date | null => {
  if (!event.dates?.length) return null

  const rawDate = event.dates[0]
  return rawDate instanceof Date ? rawDate : parseISO(String(rawDate))
}

export const getUpcomingStartDate = (
  event: Event,
  referenceDate: Date = new Date(),
): Date | null => {
  const startDate = getEventStartDate(event)
  if (!startDate) return null

  if (!isYearlyRecurringEvent(event)) {
    return startDate
  }

  const year = referenceDate.getFullYear()
  let nextOccurrence = setYear(startDate, year)

  if (isBefore(startOfDay(nextOccurrence), startOfDay(referenceDate))) {
    nextOccurrence = addYears(nextOccurrence, 1)
  }

  return nextOccurrence
}

export const getUpcomingEvents = (
  events: Event[],
  daysCount: number,
): Event[] => {
  const now = new Date()
  const from = startOfDay(now)
  const to = endOfDay(addDays(now, daysCount))

  return events
    .filter((event) => {
      const upcomingStartDate = getUpcomingStartDate(event, now)
      if (!upcomingStartDate) return false

      return !isBefore(upcomingStartDate, from) && !isAfter(upcomingStartDate, to)
    })
    .sort((a, b) => {
      const dateA = getUpcomingStartDate(a, now)
      const dateB = getUpcomingStartDate(b, now)

      if (!dateA && !dateB) return 0
      if (!dateA) return 1
      if (!dateB) return -1

      return dateA.getTime() - dateB.getTime()
    })
}
